import React from 'react';
import { ReactComponent as ArrowIcon } from './../../../assets/icons/arrow.svg';

import styles from './arrow.module.css';

/**
 * Arrow Icon
 * @param {Object} props 
 * @param {'up'|'down'|'left'|'right'} [props.direction=up] The direction to point the arrow
 */
export const Arrow = ({direction = 'up'}) => {
    return <div className={styles.Arrow + ' icon'}>
        <ArrowIcon style={{
            transform: `rotate(${
                (direction === 'up') ? '180'
                : (direction === 'down') ? '0'
                : (direction === 'right') ? '270'
                : '90'
            }deg)`
        }}/>
    </div>
}